module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "flat ma-0 pa-0",
    attrs: {
      "indeterminate": true,
      "height": 3
    }
  }), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Choose a background "), _c('span', {
    staticClass: "hidden-sm-and-down"
  }, [_vm._v(" for your website")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-3",
    attrs: {
      "label": "Search background images",
      "append-icon": "search"
    },
    on: {
      "click:append": _vm.search,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  })], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-sm": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.images), function(img) {
    return _c('v-flex', {
      key: img.id,
      staticClass: "text-xs-center",
      attrs: {
        "xs4": "",
        "md3": "",
        "lg2": ""
      }
    }, [(_vm.activeImg === img.id) ? _c('div', {
      staticClass: "mt-3"
    }, [_c('v-progress-circular', {
      attrs: {
        "indeterminate": "",
        "size": 50,
        "color": "amber"
      }
    }), _vm._v(" "), _c('div', [_vm._v("Setting background")])], 1) : _c('img', {
      staticClass: "image",
      attrs: {
        "src": img.urls.thumb
      },
      on: {
        "click": function($event) {
          return _vm.save(img)
        }
      }
    })])
  }), 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 10000,
      "top": ""
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    Background image updated\n    "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "pink"
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a2991e8c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/settings/UnsplashSearch.vue
// module id = 1504
// module chunks = 9